module.exports = __webpack_public_path__ + "static/Sonyax57-ed8a5537069016f5786c3f017c0c2d50.png";